<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Design System Components

	// Components
	import { getDeviceChartsConfig } from 'src/helpers/statistics/config/device_chart_config';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';
	import SidepanelMainViewHost from 'src/components/Sidepanel/SidepanelMainViewHost.svelte';

	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statusesRaw =
		status?.online && (typeof deviceConfig !== 'undefined' || device?.type === 'peripheral-device')
			? status_configurator(status, device, settings)
			: [];

	// Declare _statuses before using in reactive declarations to avoid lint error
	let _statuses: any[] = [];
	$: _statuses = Array.isArray(_statusesRaw) ? _statusesRaw : [];

	$: deviceChartsConfig = device ? getDeviceChartsConfig(device) : [];

	const handleOnClickThumbChart = () => {
		navigateToHistoryStatisticsTab();
	};

	// Make labelList reactive to status, device, and settings changes
	$: if (status?.online && typeof deviceConfig !== 'undefined') {
		const result = status_configurator(status, device, settings);
		_statuses = Array.isArray(result) ? result : [];
	}
</script>

<SidepanelMainViewHost
	{device}
	viewProps={{
		statuses: _statuses,
		deviceChartsConfig,
		handleOnClickThumbChart,
	}}
/>
